import React, {  useState, useEffect, useRef } from "react";
import { io } from 'socket.io-client';
import Peer from 'peerjs';
import { Row, Col, Card, Button, Modal, Table ,Form } from "react-bootstrap";
import Navbar from "../component/Navbar";
import "../css/Telemedicine.css";
import axios from "axios";
import { useParams, useNavigate , useLocation } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { decryptData } from "../component/EncryptACCESSION_NO";
//Image
import Reportimg from "../img/report.png";
import MicOn from "../img/micon.png";
import MicOff from "../img/micoff.png";
import SoundOn from "../img/soundOn.png";
import SoundOff from "../img/soundOff.png";
import CamOn from "../img/cameraOn.png";
import CamOff from "../img/cameraOff.png";
import FullScreen from "../img/fullScreen.png";
import ExitFullScreen from "../img/exitFullScreen.png";
import Parimg from "../img/par1.png";
import Callicon from "../img/callicon.png";
import Pacs from '../img/pacs-img.png';
import Ipserver from '../ipserver'
import Backbutton from "../img/backbutton.png";
import ReportB from "../img/reportblack.png";
import ReportW from "../img/reportwhite.png";
import { useLogin } from '../component/LoginContext';
import IpPacs from '../ipPacs';
import Notebut from "../img/notebut.png";
let socket;
let peer;

function Telemedicine() {

    const { roomId } = useParams();
    const { user, pwd } = useLogin();
    const [imgSrc, setImgSrc] = useState(ReportB);
    const [localMic, setLocalMic] = useState(true);
    const [localCamera, setLocalCamera] = useState(true);
    const [localSound, setLocalSound] = useState(true);
    const [localFull, setLocalFull] = useState(true);
    const [ patientDetail , setPatientDetails ] = useState([]);
    const [ pacsDetail , setPacsDetail ] = useState([]);
    const [isReady, setIsReady] = useState(false);
    const [showModals, setShowModals] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [isCallActive, setIsCallActive] = useState(false);
    const [isDataFetched, setIsDataFetched] = useState(false);
    const [myPeerId, setMyPeerId] = useState(null);
    const [error, setError] = useState(null);
    const [stream, setStream] = useState(null);
    const [snackBarMessage , setSnackBarMessage] = useState('Connection successful!');
    const [peers, setPeers] = useState({});
    const [reportData , setReportData] = useState('');
    const [otherUsers, setOtherUsers] = useState([]);
    const myVideoRef = useRef(null);
    const remoteVideoRef = useRef(null);
    const location = useLocation();
    const [showReportModals , setShowReportModals ] = useState(false);
    const navigate = useNavigate();
    const ip = Ipserver;
    const [snackbarMessage, setSnackbarMessage] = useState('Connect Success');
    const [foundNote,setFoundNote] = useState(false);
    const hasRedirected = useRef(false);
    //MBT_NOTE
    //NOTE_TEXT
    const [noteText,setNoteText] = useState('');
    //TABLE_NAME
    const [tableName,setTableName] = useState('');
    //STUDY_KEY
    const [noteStudyKey,setNoteStudyKey] = useState('');

    //IF FOUND DATA IN MBT_NOTE THIS WILL HAVE NOTE_KEY TO SEARCH FOR UPDATE.
    //NOTE_KEY
    const [noteKey,setNoteKey] = useState('');
    //Function Zone

    const handleModalClose = () => {
        setShowReportModals(false);
        setShowModals(false);
        setReportData('');
        setNoteText('');
        setNoteKey('');
        setNoteStudyKey('');
    };


    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    
    
    // ใช้ useParams เพื่อดึงค่าจาก URL



    const handleUserConnected = (userId) => {

        console.log(`[User Connected] New user joined with ID: ${userId}`);
        setOtherUsers(prev => [...prev, userId]);
        console.log('User in room : ',otherUsers);
        isReady && connectToNewUser(userId, stream);
    };

    const handleUserDisconnected = (userId) => {

        console.log(`[User Disconnected] User left with ID: ${userId}`);
        setOtherUsers(prev => prev.filter(id => id !== userId));

        peers[userId] && peers[userId].close();

    };


    const handleRoomUsers = (users) => {
        console.log('[Room Users] Current users in room:', users);
        setOtherUsers(users.filter(id => id !== myPeerId));

    };

    const handleUserReady = (userId) => {
        console.log(`[User Ready] User ${userId} is ready to connect`);

        stream && connectToNewUser(userId, stream) ;
        
    };
    const handleCall = async () => {
        try {
            console.log('[Call] Initiating call...');
            const currentStream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: true
            });
            console.log('[Call] Media stream obtained successfully');
            setStream(currentStream);
    
            addVideoStream(myVideoRef.current, currentStream);
    
            peer.on('call', call => {
                console.log('[Call] Receiving incoming call');
                call.answer(currentStream);
                call.on('stream', userVideoStream => {
                    console.log('[Call] Received remote stream');
                    addVideoStream(remoteVideoRef.current, userVideoStream);
                });
            });
    
            setIsReady(true);
            socket.emit('ready-to-connect', roomId, myPeerId);
            console.log(`[Call] Emitted ready-to-connect for room ${roomId}`);
            otherUsers.forEach(userId => {
                console.log(`[Call] Connecting to existing user: ${userId}`);
                connectToNewUser(userId, currentStream);
            });
    
            setIsCallActive(true);
            socket.emit('start-call', roomId);
            console.log('[Call] Call started successfully');
            window.history.pushState({}, '', `${window.location.origin}/#${location.pathname}`);
        } catch (error) {
            console.error('Error accessing media devices:', error);
            setError('Failed to access camera or microphone. Please check your device settings.');
            setSnackbarOpen(true);
        }
    };
    
    

    const connectToNewUser = (userId, stream) => {
        try {
            // เริ่มการโทรไปยังผู้ใช้ใหม่
            console.log(`[Connect] Attempting to connect to user: ${userId}`);
            const call = peer.call(userId, stream);
    
            call.on('stream', userVideoStream => {
                try {
                    console.log(`[Connect] Received stream from user: ${userId}`);
                    addVideoStream(remoteVideoRef.current, userVideoStream);
                } catch (streamError) {
                    console.error('Error adding remote video stream:', streamError);
                    setError('Failed to display remote video stream.');
                    setSnackbarOpen(true);
                }
            });
    
            call.on('close', () => {
                console.log(`[Connect] Call closed with user: ${userId}`);
            });
    
            // คัดลอกข้อมูลเก่าและทำการอัปเดท
            setPeers(prevPeers => ({ ...prevPeers, [userId]: call }));
        } catch (error) {
            console.error('Error connecting to new user:', error);
            setError(`Failed to connect to user ${userId}.`);
            setSnackbarOpen(true);
        }
    };
    

    const handleBack = () => {
        if (stream) {
            try {
                handleEndCall();
            } catch (error) {
                console.error('Error ending the call:', error);
                setError('Failed to end the call properly.');
                setSnackbarOpen(true);
            }
        }
        navigate('/teleinfo/' + location.pathname.split('/').pop());
    };
    
    const handleEndCall = () => {
        try {
            // หยุด stream ถ้ามี
            console.log('[End Call] Initiating call end sequence');
            if (stream) {
                stream.getTracks().forEach(track => track.stop());
            }
    
            setIsCallActive(false);
            setStream(null);
    
            // ลบ srcObject ของวิดีโอ
            if (myVideoRef.current) {
                myVideoRef.current.srcObject = null;
            }
            if (remoteVideoRef.current) {
                remoteVideoRef.current.srcObject = null;
            }
    
            // ทำความสะอาด peers
            Object.values(peers).forEach(call => {
                call.close();
            });
            setPeers({});
    
            // ส่งข้อความสิ้นสุดการโทร
            socket.emit('end-call', roomId);
            console.log(`[End Call] Emitted end-call for room ${roomId}`);
            navigate('/teleinfo/' + location.pathname.split('/').pop());
        } catch (error) {
            console.error('Error during ending the call:', error);
            setError('Failed to properly end the call. Please try again.');
            setSnackbarOpen(true);
        }
    };
    
    useEffect(() => {
        // Handler for back button
        const handleBackButton = (event) => {
            event.preventDefault();
    
            if (stream) {
                try {
                    handleEndCall();
                } catch (error) {
                    console.error('Error ending the call on back button:', error);
                    setError('Failed to end the call properly.');
                    setSnackbarOpen(true);
                }
            } else {
                navigate('/teleinfo/' + window.location.pathname.split('/').pop());
            }
    
            // Push current state to allow normal back navigation after handling
            window.history.pushState(null, '', window.location.pathname);
        };
    
        // Add state to history stack when component mounts
        window.history.pushState(null, '', window.location.pathname);
    
        // Add event listener for popstate (triggered by back button)
        window.addEventListener('popstate', handleBackButton);
    
        // Cleanup function
        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
    }, [stream]);
    

    const toggleMic = () => {
        if (stream) {
            const audioTracks = stream.getAudioTracks();
    
            if (audioTracks.length > 0) {
                const newMicState = !localMic;
                audioTracks[0].enabled = newMicState;
                setLocalMic(newMicState);
                socket.emit('toggle-mic', roomId, newMicState);
            } else {
                console.warn('No audio tracks found.');
            }
        } else {
            console.warn('No active stream found to toggle mic.');
        }
    };
    
    const toggleCamera = () => {
        if (stream) {
            const videoTracks = stream.getVideoTracks();
    
            if (videoTracks.length > 0) {
                const newCameraState = !localCamera;
                videoTracks[0].enabled = newCameraState;
                setLocalCamera(newCameraState);
                socket.emit('toggle-camera', roomId, newCameraState);
            } else {
                console.warn('No video tracks found.');
            }
        } else {
            console.error('No active stream found to toggle camera.');
        }
    };
    
    const addVideoStream = (video, stream) => {
        if (video && stream) {
            video.srcObject = stream;
            video.addEventListener('loadedmetadata', () => {
                video.play().catch(error => {
                    console.error('Error playing video:', error);
                });
            });
        } else {
            console.warn('Invalid video element or stream provided.');
        }
    };
    
    const toggleSound = () => {
        if (remoteVideoRef.current) {
            const newSoundState = !localSound;
            remoteVideoRef.current.muted = !newSoundState;
            setLocalSound(newSoundState);
        } else {
            console.warn('No remote video reference found to toggle sound.');
        }
    };
    

    // Fullscreen Button
    const toggleFullscreen = () => {
        const videobox = document.querySelector('.videobox'); // ค้นหา element ที่มี class = videobox
        if (!document.fullscreenElement) {
            // ถ้ายังไม่อยู่ในโหมดเต็มจอ
            if (videobox) {
                if (videobox.requestFullscreen) {
                    // ถ้า requestFullscreen มีอยู่ ให้เรียกใช้งาน
                    videobox.requestFullscreen().catch(error => {
                        console.error('Error attempting to enable full-screen mode:', error);
                    });
                } else if (videobox.webkitRequestFullscreen) { // สำหรับ Safari
                    videobox.webkitRequestFullscreen().catch(error => {
                        console.error('Error attempting to enable full-screen mode on Safari:', error);
                    });
                } else if (videobox.msRequestFullscreen) { // สำหรับ IE/Edge
                    videobox.msRequestFullscreen().catch(error => {
                        console.error('Error attempting to enable full-screen mode on IE/Edge:', error);
                    });
                }
                setLocalFull(false);
            } else {
                console.warn('No video box found to enter fullscreen.');
            }
        } else {
            // ถ้าอยู่ในโหมดเต็มจอแล้ว ให้ทำการออกจากโหมดเต็มจอ
            if (document.exitFullscreen) {
                document.exitFullscreen().catch(error => {
                    console.error('Error attempting to exit full-screen mode:', error);
                });
            } else if (document.webkitExitFullscreen) { // สำหรับ Safari
                document.webkitExitFullscreen().catch(error => {
                    console.error('Error attempting to exit full-screen mode on Safari:', error);
                });
            } else if (document.msExitFullscreen) { // สำหรับ IE/Edge
                document.msExitFullscreen().catch(error => {
                    console.error('Error attempting to exit full-screen mode on IE/Edge:', error);
                });
            }
            setLocalFull(true);
        }
    };

    const handleSnackbarClose = (reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
        setSnackBarMessage('Connection successful!');
    };


        
    useEffect(() => {
        if (stream) {
            // ตรวจสอบว่ามี audio track หรือไม่
            const audioTrack = stream.getAudioTracks()[0];
            if (audioTrack) {
                audioTrack.enabled = localMic;  // ใช้สถานะของ localMic ในการเปิด/ปิดเสียง
            } else {
                console.warn('No audio track found in the stream.');
            }
        } else {
            console.warn('No stream available for audio track manipulation. Please ensure that the stream is initialized before this effect runs.');
        }
    }, [localMic, stream]);


    // Fullscreen
    useEffect(() => {
        const handleFullscreenChange = () => {
            if (!document.fullscreenElement) {
                setLocalFull(true);
                console.log('Exited fullscreen mode.');
            } else {
                console.log('Entered fullscreen mode.');
            }
        };

        // เพิ่ม event listener เมื่อ component นี้ถูก mount
        document.addEventListener('fullscreenchange', handleFullscreenChange);

        // ลบ event listener เมื่อ component นี้ถูก unmount
        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, []); 

    function splitParameters(paramString) {
        const params = {};
        const accMatch = paramString.match(/Acc=([0-9]+)/); // หา Acc โดยใช้ regex
        const tableMatch = paramString.match(/Table=(.+)/); // หา Table โดยใช้ regex
        
        if (accMatch) {
            params['Acc'] = accMatch[1]; // เก็บค่า Acc
        } else {
            console.warn('No Acc parameter found in the string.');
        }

        if (tableMatch) {
            params['Table'] = tableMatch[1]; // เก็บค่า Table
        } else {
            console.warn('No Table parameter found in the string.');
        }
        
        return params;
    }


    useEffect(() => {
        const fetchPatientDetails = async () => {
            try {
                const decryptedData = decryptData(location.pathname.split('/').pop());
                const { Acc, Table } = splitParameters(decryptedData);
                console.log('Table : ',Table);
                setTableName(Table);
                // เริ่มต้นการดึงข้อมูลผู้ป่วย
                const response = await axios.get(`https://${ip}/api/GetPatientInfo/${Acc}/${Table}`);
                setPatientDetails(response.data);
        
                // ตรวจสอบข้อมูลที่ได้รับ
                if (response.data.length === 0) {
                    throw new Error("No patient data found.");
                }
                
                if (Table === 'STUDY') {
                    const response2 = await axios.get(`https://${ip}/api/GetPacsForTelemedicine`, {
                        params: {
                            id: response.data[0].PATIENT_ID
                        }
                    });
                    setPacsDetail(response2.data);
                }
        


                // if (response.data[0].STUDY_STAT >= 240 && Table === 'STUDY') {
                //     setReportButton(true);
                //     const responseReport = await axios.get(`https://${ip}/api/GetReport`, {
                //         params: {
                //             accession: response.data[0].ACCESS_NO
                //         }
                //     });
                //     setReportData(responseReport.data);
                // } else {
                //     setReportButton(false);
                // }
                setIsDataFetched(true);
            } catch (error) {
                console.error("Error fetching patient details: ", error);
                setError(`Failed to fetch patient details: ${error.message}`); // เพิ่มข้อความแสดงข้อผิดพลาด
                setSnackbarOpen(true); // เปิด Snackbar เพื่อแสดงข้อความแสดงข้อผิดพลาด
            }
        };
        console.log('[Initialize] Setting up WebRTC connection');
        console.log('User in room : ',otherUsers);
        
        socket = io(`https://mbtm.thaigl.com`, { 
        // socket = io(`${ip}`, { 
            withCredentials: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
            secure: true 
        });
    
        peer = new Peer(undefined, {

            // host: ip.replace(":5000",""),
            // secure: true,
            // path: "/peerjs",
            // port: 5001,
            host: "peer.thaigl.com",
            secure: true,
            path: "/",
            config: {
                iceServers: [
                    { urls: 'stun:stun.l.google.com:19302' },
                    { urls: 'stun:stun1.l.google.com:19302' },
                    { urls: 'stun:stun2.l.google.com:19302' }
                ]
            }
        });
    
        peer.on('open', userId => {
            setMyPeerId(userId);
            socket.emit('join-room', roomId, userId);
        });
    
        socket.on('connect', () => {
            console.log('[Socket] Connected to server');
        });

        socket.on('disconnect', () => {
            console.log('[Socket] Disconnected from server');
        });
        socket.on('user-connected', handleUserConnected);
        socket.on('user-disconnected', handleUserDisconnected);
        socket.on('room-users', handleRoomUsers);
        socket.on('user-ready', handleUserReady);
        
        fetchPatientDetails(); // เรียกใช้งานฟังก์ชันเพื่อดึงข้อมูลผู้ป่วย
        console.log(`${window.location.origin}/#${location.pathname}`);
        window.history.pushState({}, '', `${window.location.origin}/#${location.pathname}`);
        return () => {
            socket && socket.disconnect();
            peer && peer.destroy();
            stream && stream.getTracks().forEach(track => track.stop());
        };
    }, [roomId]);
    

    const OpenPacs = (access_no) => {
        const ippacs = IpPacs;
        window.open(`http://${ippacs}/pkg_pacs/external_interface.aspx?TYPE=V&LID=${user?.name}&LPW=${pwd?.pass}&AN=${access_no}`)

    }


    const SubDate = (date) => {
        // แปลง string เป็น Date object
        const originalDate = new Date(date);

        // ดึงข้อมูลวัน เดือน และ ปี
        const day = String(originalDate.getDate()).padStart(2, '0');
        const month = String(originalDate.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มที่ 0 ต้องบวก 1
        const year = originalDate.getFullYear();

        // ดึงข้อมูลเวลา ชั่วโมง นาที วินาที
        const hours = String(originalDate.getHours()).padStart(2, '0');
        const minutes = String(originalDate.getMinutes()).padStart(2, '0');
        const seconds = String(originalDate.getSeconds()).padStart(2, '0');

        // จัดรูปแบบเป็น DD-MM-YYYY HH:mm:ss
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    }
    const handleNoteChange = (e) => {
        
        setNoteText(e.target.value)
    };

    const handleModalSave = async() => {
        
        if(foundNote){
            try{
                console.log(noteKey);
                console.log(noteStudyKey);
                console.log(tableName);
                console.log(user.name);
                console.log(noteText);
                await axios.put(`https://${Ipserver}/api/UpdateNote`,{
                    NOTE_KEY:noteKey,
                    STUDY_KEY:noteStudyKey,
                    TABLE_NAME:tableName,
                    USER_ID:user?.name,
                    NOTE_TEXT:noteText
                })

                setSnackbarOpen(true)
                setSnackBarMessage('Save note success')
            }
            catch (err){
                console.error('Error updating note:', err);
                setSnackbarOpen(true); // แจ้งว่ามีข้อผิดพลาด
                setSnackbarMessage('Error updating note!'); 
            }
            
        }
        else{
            try{
                const response = await axios.post(`https://${Ipserver}/api/AddNote`,{
                    STUDY_KEY:noteStudyKey,
                    TABLE_NAME:tableName,
                    USER_ID:user?.name,
                    NOTE_TEXT:noteText
                })
                setNoteKey(response.data.noteKey);
                setSnackbarOpen(true);
                setFoundNote(true);
                setSnackBarMessage('Create note success')
            }
            catch (err) {
                console.error('Error for create data to mbt_note : ', err);
                setSnackbarOpen(true); // แจ้งว่ามีข้อผิดพลาด
                setSnackbarMessage('Error creating note!'); 
            }
        }
    };
    const handleModalShow = async (key , tablename) => {
        
        try {
            console.log('Get Note AccessNo : ',key);
            console.log('Get Note Table Name : ',tablename);
            const response = await axios.get(`https://${Ipserver}/api/GetNote`, {
                params: {
                    search: key,
                    tablename:tablename
                }
            });
            console.log(response.data);
            const data = response.data;
            if(data.length > 0){
                setNoteText(data[0].NOTE_TEXT);
                setNoteKey(data[0].NOTE_KEY);
                setFoundNote(true);
                console.log('Found Note.');
            }
            else{
                setFoundNote(false);
                console.log('Note not found.');
            }
            setShowModals(true);
        } catch (err) {
            console.error('Error to search:', err);
        }
    
        
    };
    const OpenReport = async(data) => {
        const response = await axios.get(`https://${Ipserver}/api/GetReport`,{
            params:{
                accession:data
            }
        });
        setShowReportModals(true);
        setReportData(response.data);
    }
    const TableBody = () => {
            return pacsDetail.map( (d,i ) => {
                return (
                    
                        <tr key={i}>
                            <th className="dataXray">{SubDate(d.REQUEST_DTTM)}  </th>

                            <th className="dataXray">{d.STUDY_DESC}</th>

                            <th className="dataXray">
                                <a href="#" onClick={(e) => {e.preventDefault();handleModalShow(d.ACCESS_NO,d.TABLE_NAME);setNoteStudyKey(d.STUDY_KEY);}}>
                                    <img className="pacsimg" src={Notebut}/>
                                </a> 
                            </th>

                            <th className="dataXray">
                                {d.STUDY_STAT >= 240 && d.TABLE_NAME == 'STUDY' ? 
                                <a  href='#' onClick={(e) => {e.preventDefault();OpenReport(d.ACCESS_NO);}}>
                                    <img className='boxicon' src={Reportimg} alt='report' />
                                </a>
                                :   null
                                }
                                
                            </th>
                            
                            <th className="dataXray">
                                {d.STUDY_STAT >= 200 && d.TABLE_NAME == 'STUDY' ? 
                                <a href="#" onClick={(e) => {e.preventDefault();OpenPacs(d.ACCESS_NO)}}>
                                    <img className="pacsimg" src={Pacs}/>
                                </a> :
                                null
                                }
                            </th>
                        </tr>
                )
            });
    }

    return (
        <>
            <Modal 
                show={showReportModals}  
                onHide={handleModalClose} 
                centered 
                dialogClassName="custom-modal"
            >
                <Modal.Header className="d-flex justify-content-between align-items-center"> 
                    <h1 className='m-0'>Report</h1> 
                    <Button 
                        variant="close" 
                        onClick={handleModalClose} 
                    />
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className='mt-2'>
                        <Form.Control 
                            readOnly  
                            id='reportValue' 
                            value={reportData || ''} 
                            as="textarea" 
                            rows={15} 
                        />
                    </Form.Group>
                </Modal.Body>
            </Modal>
            
            <Modal show={showModals}  onHide={handleModalClose} centered>
                <Modal.Header>
                    <h1 className='text-center'>Note </h1>
                    <Button 
                        variant="close" 
                        onClick={handleModalClose} 
                    />
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className='mt-2'>
                        <Form.Label >Note Detail</Form.Label>
                        <Form.Control id='notevalue' value={noteText || ''} as="textarea" rows={15} onChange={handleNoteChange}></Form.Control>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className='modalbutt'>
                    <Button onClick={handleModalClose} className='button btn-danger me-3'>Cancel</Button>
                    <Button onClick={handleModalSave} className='button btn-primary'>Save</Button>
                </Modal.Footer>
            </Modal>
            <Navbar />

            <Card className="cardworklist mt-3 cardpardetail">
                <Card.Body>
                    <Row className="d-flex ">
                        <Col  className="parimg-container">
                            <img className="parimg" src={Parimg} alt="parimg" />
                        </Col>
                        <Col className="patient-info-container">
                            {isDataFetched ? (
                                <h5 className="mt-2 patientDataDetail">
                                    {patientDetail[0]?.PATIENT_ID}, {patientDetail[0]?.PATIENT_NAME}, {(patientDetail[0]?.PATIENT_SEX === 'M' ? 'Male' : 'Female')}, รายการตรวจ : {patientDetail[0]?.STUDY_DESC}
                                </h5>
                            ) : (
                                <h4>Loading...</h4> // แสดงข้อความ Loading หรือ Spinner ในระหว่างที่รอข้อมูล
                            )}
                        </Col>
                        <Col  className="text-end button-container ">
                            <Button
                                variant="outline-black"
                                className="backbutton btn-secondary"
                                onClick={() => handleBack()}
                            >
                                <img className="pardetailicon me-2" src={Backbutton} alt="Patient Info" />
                                ย้อนกลับ
                            </Button>
                            <Button
                                variant='outline-secondary'
                                className="ReportButton"
                                onMouseEnter={() => setImgSrc(ReportW)}
                                onMouseLeave={() => setImgSrc(ReportB)}
                                onClick={() => {handleModalShow(patientDetail[0].ACCESS_NO , tableName);setNoteStudyKey(patientDetail[0].STUDY_KEY);}}
                            >
                                <img className="pardetailicon me-2" src={imgSrc} alt="Patient Info" />
                                Note
                            </Button>
                            <Button
                                className={`callbutton ${isCallActive ? 'btn-danger' : 'btn-success'}`}
                                onClick={isCallActive ? handleEndCall : handleCall}
                            >
                                <img className="callparicon me-2" src={Callicon} alt="Call" />
                                {isCallActive ? 'วางสาย' : 'โทร'}
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="cardworklist mt-3">
                <Card.Body>
                    <Row className="justify-content-center">
                        <Col className="ms-3 mt-3" md={6}>
                            <Card>
                                <Card.Body className="videobox d-flex align-items-center justify-content-center">
                                    <video ref={myVideoRef} className="video-grid selfvideoimg" playsInline muted></video>
                                    <video ref={remoteVideoRef} id="remotevideo" className="video-grid videoimg remotevideoimg"></video>

                                    <button className="micbut" onClick={toggleMic}>
                                        <img src={localMic ? MicOn : MicOff} className="micicon" alt="Mic" />
                                    </button>

                                    <button className="soundbut" onClick={toggleSound} >
                                        <img src={localSound ? SoundOn : SoundOff} className="soundicon" alt="Sound"/>
                                    </button>

                                    <button className="camerabut" onClick={toggleCamera}>
                                        <img src={localCamera ? CamOn : CamOff} className="cameraicon" alt="Camera" />
                                    </button>

                                    <button className="fullscreenbut" onClick={toggleFullscreen}>
                                        <img src={localFull ? FullScreen : ExitFullScreen} className="fullscreenicon" alt="fullscreen" />
                                    </button>

                                </Card.Body>
                            </Card>
                        </Col>
                        <Col >
                            {/* ส่วนภาพ X-ray คนไข้ */}
                            <Row>
                                <h3 className="text-center mt-3">รายการตรวจเอกซเรย์</h3>
                            </Row>
                            <Row>
                                <Card style={{ border: 'none' }}>
                                    <Card.Body className="tablecon">
                                        
                                        <Table striped hover variant="secondary" className="text-center mt-3">
                                            <thead>
                                                <tr>
                                                    <th className="headtableXray">DATE</th>
                                                    <th className="headtableXray">DESCRIPTION</th>
                                                    <th className="headtableXray">NOTE</th>
                                                    <th className="headtableXray">REPORT</th>
                                                    <th className="headtableXray">PACS</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isDataFetched ? <TableBody/>: 
                                                    <tr>
                                                        <td><p>Loading</p></td>
                                                        <td><p>Loading</p></td>
                                                        <td><p>Loading</p></td>
                                                        <td><p>Loading</p></td>
                                                        <td><p>Loading</p></td>
                                                    </tr>}
                                            </tbody>
                                        </Table>


                                    </Card.Body>
                                </Card>
                            </Row>
                            
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
                <Alert onClose={handleSnackbarClose} severity={error ? "error" : "success"}>
                    {error || snackBarMessage}
                </Alert>
            </Snackbar>
        </>
    );
}



export default Telemedicine;